var _g, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPdFdoc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17046",
    fill: "none",
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11851",
    d: "M18.414 6.414l-2.828-2.828A2 2 0 0014.172 3H7a2 2 0 00-2 2v14a2 2 0 002 2h10a2 2 0 002-2V7.828a2 2 0 00-.586-1.414z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11852",
    d: "M19 8h-4a1 1 0 01-1-1V3"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11853",
    d: "M10.34 16.55h3.32"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11854",
    d: "M10.833 12.751v-1.168a.583.583 0 01.583-.583h1.168a.583.583 0 01.583.583v1.168a.583.583 0 01-.583.583h-1.168a.584.584 0 01-.583-.583z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11855",
    d: "M8 17.417v-1.168a.583.583 0 01.583-.583h1.168a.583.583 0 01.583.583v1.168a.583.583 0 01-.583.583H8.583A.583.583 0 018 17.417z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11856",
    d: "M13.667 17.417v-1.168a.583.583 0 01.583-.583h1.168a.583.583 0 01.583.583v1.168a.584.584 0 01-.584.583h-1.168a.583.583 0 01-.582-.583z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11857",
    d: "M14.24 15.67l-1.51-2.36"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11858",
    d: "M9.76 15.67l1.51-2.36"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11859",
    d: "M0 0h24v24H0z",
    fill: "none"
  })));
}

export default SvgPdFdoc;


//////////////////
// WEBPACK FOOTER
// ./src/icons/PDFdoc.svg
// module id = 885
// module chunks = 101